import store from '../store';

export const getGlobalReducer = (state = store) => state.globalReducer

export const getGlobalNotification = (state = store) => getGlobalReducer(state).notification
